app.controller('checkoutController', function (
    $scope,
    $state,
    objectService,
    questionService,
    imageService,
    $uibModal
) {
    var object

    $scope.readOnly              = objectService.readOnly
    $scope.previewMode           = objectService.previewMode
    $scope.designLine            = objectService.getSelectedDesignLine()
    $scope.isLoading             = true
    $scope.object                = object = objectService.getObject()
    $scope.groups                = []
    $scope.isAlternativeDisabled = objectService.isAlternativeDisabled
    $scope.isQuestionDisabled    = objectService.isQuestionDisabled
    $scope.isGroupDisabled       = objectService.isGroupDisabled
    $scope.isTillvalslinje       = objectService.isTillvalslinje

    $scope.hasEarlyChoices = objectService.hasEarlyChoices()
    $scope.hasDesignChoices = objectService.hasDesignChoices()

    $scope.typeFilter

    $scope.getPrice = objectService.calcPrice

    $scope.setFilter = function(value){
        $scope.typeFilter = value
    }

    $scope.display = (function(){
        if(objectService.isInEarlyChoices() || !objectService.hasDesignChoices()) {
            return 'early'
        } else if(objectService.isInDesignChoices() || !objectService.hasEarlyChoices()) {
            return 'design'
        } else if(objectService.previewMode){
            return null
        } else {
            return 'both'
        }
    })();

    $scope.getAnswer = function(question,answerId){
        return getWhereId(question.alternatives,answerId)
    }

    $scope.getAnswerImage = function (answer) {
        if(answer && answer.media.primary_image){
            return answer.media.primary_image.url
        }
        return null
    }

    $scope.doesObjectStatusAllowEdit = function() {
        return (objectService.previewMode && !objectService.readOnly) ||
        (
            object.status == STATUS.EARLY_CHOICES_PENDING
        ) || (
            object.status == STATUS.DESIGN_CHOICES_PENDING
        )
    }

    $scope.isQuestionAnswerEditable = function (question) {
        return $scope.doesObjectStatusAllowEdit()
            && question.alternatives.length > 1
    }

    $scope.goToQuestion = function (group, question) {
        questionService.setSubsequentGoTo(group, question)
        $state.go('design')
    };

    function checkout() {
        objectService.save().then(function () {
            $state.go('start')
        })
    }

    $scope.confirm = function () {
        $uibModal.open({
            animation: true,
            templateUrl: 'partials/checkout/confirm_modal.html',
            controller: ['$scope', function ($scope) {
                $scope.confirm = function () {
                    checkout()
                    $scope.$close()
                }
            }],
        })
    }

    $scope.getTemplate = function() {
        switch(true){
            case object.status == STATUS.NEW:
                return 'partials/start/not_open.html'
            case object.status == STATUS.EARLY_CHOICES_PENDING:
                return 'partials/start/early_choices.html'
            case object.status == STATUS.EARLY_CHOICES_SIGNING || object.status == STATUS.EARLY_CHOICES_COMPLETE:
                return 'partials/start/early_choices_done.html'
            case object.status == STATUS.DESIGN_CHOICES_PENDING:
                return 'partials/start/design_choices.html'
            case object.status >= STATUS.DESIGN_CHOICES_SIGNING:
                return 'partials/start/design_choices_done.html'
            case object.status >= STATUS.COMPLETED:
                return 'partials/start/done.html'
            default:
                return 'partials/start/idle.html'
        }
    }

    $scope.isChosenTillvalslinje = function (group) {
        var nrOfTrueQuestions = 0;

        for(var i = 0; i < group.questions.length; i++){
            if(group.questions[i].answer == true){
                nrOfTrueQuestions++
                if(nrOfTrueQuestions >= 4){
                    $scope.chosenGroup = group.id
                    return true
                }
            }
        }
        /*})*/
    }

    if(objectService.previewMode || objectService.isInEarlyChoices() || objectService.isInDesignChoices()) {
        if (!objectService.getQuestionGroups().length) {
            objectService.fetchObjectQuestions().then(function () {
                $scope.groups = objectService.getQuestionGroups()
                $scope.isLoading = false
            })
        } else {
            $scope.groups = objectService.getQuestionGroups()
            $scope.isLoading = false
        }
    } else {
        var configurationsToLoad = object.configurations.length
        objectService.clearObjectQuestions()
        angular.forEach(object.configurations,function(configuration){
            objectService.fetchObjectQuestions(configuration.id,true).then(function (question_groups) {

                question_groups.map(function(group){
                    group.type = configuration.data.type
                })

                if(!(--configurationsToLoad)){
                    $scope.isLoading = false
                    $scope.groups = objectService.getQuestionGroups()
                }
            })
        })
    }


});
